export const resourceSubCategoryEditComponent = {

    template: `
            <resources-subcategory-main
            details = '$ctrl.details',
            title="edit resource"
            on-cancel='$ctrl.onCancel(isUpdated)'
            on-submit='$ctrl.onSubmit(details)'
            disable-buttons='$ctrl.disableButtons'>
            </resources-subcategory-main>
            `,
    bindings: {
        details: '<'
    },

    controller: class ResourceSubCategoryEditComponent {

        constructor($state, CompareObjectService, ModalService, toastr, Constants, resourcesService, $stateParams, $anchorScroll, $timeout) {
            'ngInject';

            this.$state = $state;
            this.compareObjectService = CompareObjectService;
            this.Constants = Constants;
            this.resourcesService = resourcesService;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            this.$anchorScroll = $anchorScroll;
            this.toastr = toastr;
            this.modalService = ModalService;
        }

        $onInit() {
            this.resourceId = this.$stateParams.resource_id;
            this.slug = this.$stateParams.slug
            this.saveData = angular.copy(this.details);
        }


        onSubmit(details) {
            let _details = {
                name: details.name,
                url: details.link
            }
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, details, true);
            if (isUpdated) {
                this.disableButtons = true;
                this.resourcesService.updateSubCategory(_details, this.slug, details.id)
                    .then((_) => {
                        this.toastr.success('Category updated successfully');
                        this.$state.go('resourceCategory', {
                            slug: this.slug
                        });

                    }).catch((err) => {
                        this.disableButtons = false;
                        this.toastr.error(err);
                    });
            } else {
                this.toastr.success('Nothing to update');
                this.$state.go('resourceCategory', {
                    slug: this.slug
                });

            }
        }

        onCancel(isUpdated) {
            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: () => {
                            this.$state.go('resourceCategory', { slug: this.slug });
                        }
                    }]
                });
            } else {
                this.$state.go('resourceCategory', { slug: this.slug });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/resources/resource-subcategory-edit/resource-subcategory-edit.component.js